<template>
  <div class="safedig-login-page" v-loading.fullscreen.lock="loading">
    <SafeDigHeader />
    <div class="safedig-login-main">
      <div class="safedig-login-content">
        <div class="safedig-login-card">
        <div class="safedig-login-card-header">{{ $t('login.pleaseSignIn') }}</div>
        <div class="safedig-login-card-body">
          <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
            <form role="form" @submit.prevent="handleSubmit(onSubmit)">
              <div class="safedig-form-group">
                <label class="safedig-label">{{ $t('login.username') }}</label>
                <base-input alternative class="safedig-input-wrap" name="Username" :rules="{ required: true }"
                  placeholder="" v-model="form.username" />
              </div>
              <div class="safedig-form-group safedig-password-wrap">
                <label class="safedig-label">{{ $t('login.password') }}</label>
                <base-input alternative class="safedig-input-wrap" name="Password" :rules="{ required: true }"
                  :type="passwordFieldType" placeholder="" v-model="form.password" />
                <button type="button" class="safedig-password-toggle"
                  :aria-label="passwordFieldType === 'password' ? 'Show password' : 'Hide password'"
                  @click="togglePasswordVisibility">
                  <svg v-if="passwordFieldType === 'password'" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="safedig-eye-icon">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                  </svg>
                  <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="safedig-eye-icon">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.228 3.228m3.228 3.228 3 3m-3.228-3.228-3.228 3.228" />
                  </svg>
                </button>
              </div>
              <div class="safedig-submit-wrap">
                <base-button native-type="submit" class="safedig-submit-btn">
                  {{ $t('login.submit') }}
                </base-button>
              </div>
              <p class="safedig-error" v-if="errors.invalid">{{ errors.invalid }}</p>
            </form>
          </validation-observer>
          <div class="safedig-login-links">
            <router-link to="/forgot_password" class="safedig-link">{{ $t('login.forgotUsernameOrPassword') }}</router-link>
            <p class="safedig-create-account">
              {{ $t('login.dontHaveAccount') }}
              <router-link to="/register" class="safedig-link">{{ $t('login.createAccount')
                }}</router-link>
            </p>
            <p class="safedig-report-issue">
              <a @click.prevent="showModal()" class="safedig-link" style="cursor: pointer;">
                Report an Issue?
              </a>
            </p>
          </div>
        </div>
        </div>
      </div>
    </div>
    <div class="siteFooter footerOffWhite safedigFooter safedigLoginFooter">
      <div class="safedigCustomFooter">
        <div>
          <img src="../../../assets/safe-dig/safedig_logo_grayscale-01.png" class="safedigindiana811Logo"
            alt="Safe Dig Indiana" />
        </div>
        <p class="copyright">
          {{ $t('footer.copyright', { year }) }}<br>
          {{ $t('footer.allRightsReserved') }}
        </p>
      </div>
    </div>
    <modal :show.sync="showReportModal" class="">
      <h3 slot="header" class="title title-up text-primary">
        Report an Issue or Share Feedback
      </h3>
      <small>
        <strong>
          If you've encountered a problem or have suggestions to improve your experience, please let us know. Your input helps us serve you better.
        </strong>
      </small>
      <div class="row mt-2">
        <div class="col-md-12">
          <!-- Name Input -->
          <div class="form-group">
            <label>Name</label>
            <input
              type="text"
              v-model="account.name"
              placeholder="Name"
              class="form-control"
            />
          </div>

          <!-- Email Input -->
          <div class="form-group">
            <label>Email</label>
            <input
              type="email"
              v-model="account.email"
              placeholder="Email"
              class="form-control"
            />
          </div>

          <base-input label="Select Issue">
            <el-select class="select-primary" v-model="account.issue" placeholder="Select Issue">
              <el-option class="select-primary" v-for="item in feedbackCategories" :key="item.key" :label="item.value"
                :value="item.value">
              </el-option>
            </el-select>
          </base-input>

          <div class="form-group">
            <label>Comments</label>
            <textarea
              v-model="account.comments"
              placeholder="Enter your comments here..."
              class="form-control"
              rows="4"
            ></textarea>
          </div>
          <div class="text-right">
            <base-button
              class="greybtn"
              outline
              @click="hideModal()"
            >
              Close
            </base-button>
            <base-button
              type="primary"
              @click="submitData()"
            >
              Submit
            </base-button>
        </div>
      </div>
        </div>

    </modal>
  </div>
</template>

<script>
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { Option, Select } from 'element-ui';
import SafeDigHeader from '@/components/safe-dig/Header.vue';

export default {
  name: 'SafeDigLogin',
  components: {
    SafeDigHeader,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      loading: false,
      showReportModal: false,
      feedbackCategories: [
        { key: 'general_feedback', value: 'General Feedback' },
        { key: 'logging_in', value: 'Logging In' },
        { key: 'course_taking', value: 'Course Taking' },
        { key: 'course_assigning', value: 'Course Assigning' },
        { key: 'user_creation_updating', value: 'User Creation/Updating' },
        { key: 'location_creation_updating', value: 'Location Creation/Updating' },
        { key: 'platform_not_working', value: 'Platform Not Working' },
        { key: 'other', value: 'Other' }
      ],
      account: {
        name: '',
        email: '',
        issue: '',
        comments: ''
      },
      form: {
        username: '',
        password: ''
      },
      passwordFieldType: 'password',
      errors: {
        invalid: ''
      },
      year: new Date().getFullYear()
    };
  },
  created() {
    if (this.$route.query.email && this.$route.query.password) {
      this.form.username = this.$route.query.email;
      this.form.password = this.$route.query.password;
      this.onSubmit();
    }
  },
  methods: {
    showModal() {
      this.showReportModal = true;
    },
    hideModal() {
      this.showReportModal = false;
    },
    submitData() {
      this.$http
        .post('support', {
          name: this.account.name,
          email: this.account.email,
          issue: this.account.issue,
          comments: this.account.comments
        })
        .then((resp) => {
          Swal.fire({
            icon: 'success',
            title: 'Message Sent',
            text: resp.data.message || 'Your support request was sent successfully!'
          });
          this.account = {
            name: '',
            email: '',
            issue: '',
            comments: ''
          };
          this.hideModal();
        })
        .catch((error) => {
          let errorText = 'Something went wrong. Please try again.';

          // Laravel validation error (422)
          if (error.response && error.response.status === 422) {
            if (typeof error.response.data.errors === 'object') {
              const messages = Object.values(error.response.data.errors)
                .flat()
                .join('\n');
              errorText = messages;
            } else if (error.response.data.message) {
              errorText = error.response.data.message;
            }
          }

          // Laravel general error
          else if (error.response && error.response.data && error.response.data.message) {
            errorText = error.response.data.message;
          }

          Swal.fire({
            icon: 'error',
            title: 'Submission Failed',
            text: errorText
          });
        });
    },
    togglePasswordVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    },
    onSubmit() {
      this.errors.invalid = '';
      this.loading = true;
      const self = this;
      this.$http
        .post('user/login', {
          email: this.form.username,
          password: this.form.password
        })
        .then(resp => {
          localStorage.setItem('hot-token', resp.data.token);
          localStorage.setItem('hot-email', resp.data.email);
          localStorage.setItem('hot-user', resp.data.role);
          localStorage.setItem('hot-logged-user', resp.data.user_id);
          localStorage.setItem('hot-user-full-name', resp.data.full_name);
          localStorage.setItem('other-company-login', 'login');
          const headers = {
            authorization: 'Bearer ' + resp.data.token,
            'content-type': 'application/json'
          };
          this.$http.defaults.headers.authorization = 'Bearer ' + resp.data.token;
          let admin = '';
          switch (resp.data.role) {
            case 'super-admin':
              admin = 'super_admin';
              localStorage.setItem('hot-sidebar', admin);
              this.$http.post('company/managerdata', { email: this.form.username }, { headers }).then(r => {
                localStorage.setItem('hot-user-id', r.data[0].id);
                this.$router.push('/dashboard');
              });
              break;
            case 'company-admin':
              admin = 'admin';
              localStorage.setItem('hot-sidebar', admin);
              this.$http.post('company/data', { email: this.form.username }, { headers }).then(r => {
                if (r.data.level) localStorage.setItem('hot-company-level', 'parent');
                else localStorage.setItem('hot-company-level', 'child');
                localStorage.setItem('hot-admin-id', r.data.admin_id);
                localStorage.setItem('hot-user-id', r.data[0].id);
                localStorage.setItem('hot-company-name', r.data[0].name);
                const redirectPath = localStorage.getItem('redirect-path');
                this.$router.push(redirectPath === '/payment-information' ? redirectPath : '/dashboard');
              });
              break;
            case 'manager':
              admin = 'manager';
              localStorage.setItem('hot-sidebar', admin);
              this.$http.post('company/managerdata', { email: this.form.username }, { headers }).then(r => {
                localStorage.setItem('hot-user-id', r.data.user.id);
                localStorage.setItem('hot-admin-id', r.data.company_id);
                localStorage.setItem('hot-user-name', r.data.user.full_name);
                localStorage.setItem('hot-user-number', r.data.user.phone_num);
                localStorage.setItem('hot-user-2fa', r.data.user.is_2f_authenticated);
                const redirectPath = localStorage.getItem('redirect-path');
                this.$router.push(redirectPath === '/payment-information' ? redirectPath : '/dashboard');
              });
              break;
            case 'employee':
              admin = 'employee';
              localStorage.setItem('hot-sidebar', admin);
              this.$http.post('employees/user_data', { user_name: this.form.username }, { headers }).then(r => {
                localStorage.setItem('hot-user-id', r.data[0].id);
                localStorage.setItem('hot-user-name', r.data[0].full_name);
                localStorage.setItem('hot-user-number', r.data[0].phone_num);
                localStorage.setItem('hot-user-2fa', r.data[0].is_2f_authenticated);
                if (r.data[0].employee_status == 0) {
                  this.errors.invalid = 'Account is Deactivated by Admin..!!';
                } else {
                  const redirectPath = localStorage.getItem('redirect-path');
                  this.$router.push(redirectPath === '/payment-information' ? redirectPath : '/dashboard');
                }
              });
              break;
            case 'sub-admin':
              admin = 'sub_admin';
              localStorage.setItem('hot-sidebar', admin);
              this.$http.post('company/managerdata', { email: this.form.username }, { headers }).then(r => {
                localStorage.setItem('hot-user-id', r.data[0].id);
                this.$router.push('/dashboard');
              });
              break;
            default:
              this.errors.invalid = 'Not Valid..!!';
          }
        })
        .catch(function (error) {
          let errorText = 'Something went wrong! Please try again later.';
          if (error.response && error.response.status === 422) {
            errorText = error.response.data.message;
          }
          if (error.response && error.response.data.is_company_active === false) {
            Swal.fire({
              title: 'Account Inactive',
              html: 'The company you were assigned to is inactive. Click Proceed to be transferred to an individual account where you can take courses and have access to your certificates.',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Proceed',
              cancelButtonText: 'Cancel'
            }).then((result) => {
              if (result.isConfirmed) {
                self.$http.post('user/transfer', { email: self.form.username }).then(() => {
                  Swal.fire({ title: 'Success!', text: 'You have been successfully moved to an individual account.', icon: 'success' });
                }).catch(() => {
                  Swal.fire({ title: 'Error!', text: 'Failed to proceed. Please try again later.', icon: 'error' });
                });
              }
            });
            return;
          }
          if (error.response && error.response.data.company_user_active === false) {
            Swal.fire({
              title: 'Account Inactive',
              html: error.response.data.message,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
            }).then((result) => {
              if (result.isConfirmed) {
                self.$http.post('user/active-user', { email: self.form.username }).then(() => {
                  Swal.fire({ title: 'Success!', text: 'Your account is reactivated', icon: 'success' });
                });
              } else {
                Swal.fire({
                  title: 'Account Inactive',
                  html: 'Would you like to proceed with an individual account?',
                  icon: 'question',
                  showCancelButton: true,
                  confirmButtonText: 'Convert to Individual Account',
                  cancelButtonText: 'Cancel'
                }).then((innerResult) => {
                  if (innerResult.isConfirmed) {
                    self.$http.post('user/active-and-transfer-user', { email: self.form.username }).then(() => {
                      Swal.fire({ title: 'Success!', text: 'Your account is reactivated as Individual User', icon: 'success' });
                    });
                  }
                });
              }
            });
            return;
          }
          Swal.fire({ title: 'Error!', html: errorText, icon: 'error' });
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>

<style scoped>
.safedig-login-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.safedig-login-main {
  flex: 1;
  display: flex;
  justify-content: center;
  padding: 2rem 1rem 3rem;
}

.safedig-login-content {
  width: 100%;
  max-width: 530px;
}

.safedig-login-card {
  width: 100%;
  max-width: 530px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #3e7799;
  border-radius: 4px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .12), 0 2px 4px 0 rgba(0, 0, 0, .08);
  display: inline-block;
  text-align: left;
  vertical-align: bottom;
  max-height: fit-content;
}

.safedig-login-card-header {
  background: #3e7799;
  color: #fff;
  padding: 10px 15px;
  font-size: 18px;
  font-weight: 700;
  border-radius: 4px 4px 0 0;
}

.safedig-login-card-body {
  padding: 10px 15px;
}

.safedig-form-group {
  margin-bottom: 1.25rem;
}

.safedig-label {
  display: block;
  font-size: 0.75rem;
  font-weight: 600;
  color: #333;
  letter-spacing: 0.02em;
  margin-bottom: 6px;
}

.safedig-password-wrap {
  position: relative;
}
.safedig-input-wrap >>> .input-group-alternative {
  box-shadow: none;
}

.safedig-input-wrap>>>.form-control {
  height: 44px;
  border: 1px solid #ccc;
  border-radius: 4px !important;
  font-size: 16px;
  background: #fff;
}

.safedig-password-toggle {
  position: absolute;
  right: 12px;
  top: 32px;
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
}

.safedig-password-toggle:hover {
  color: #1e3a5f;
}

.safedig-eye-icon {
  width: 22px;
  height: 22px;
}

.safedig-submit-wrap {
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: end;
}

.safedig-submit-btn {
  height: 44px;
  font-size: 1rem;
  font-weight: 600;
  background: #9c3c21 !important;
  border: none !important;
  border-radius: 4px !important;
  color: #fff !important;
}

.safedig-submit-btn:hover {
  background: #85341c !important;
  color: #fff !important;
}

.safedig-error {
  color: #c00;
  font-size: 0.9rem;
  margin: 0.5rem 0 0;
  text-align: center;
}

.safedig-login-links {
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid #e0e0e0;
  text-align: left;
}

.safedig-link {
  color: #1e3a5f;
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
}

.safedig-link:hover {
  text-decoration: underline;
}

.safedig-create-account {
  margin: 0.75rem 0 0;
  font-size: 0.95rem;
  color: #555;
}

.safedig-create-account .safedig-link {
  margin-left: 0.25rem;
}

.safedig-report-issue {
  margin: 0.75rem 0 0;
  font-size: 0.95rem;
  color: #555;
}

.siteFooter {
  width: 100%;
}

.safedigFooter {
  background: #e8e8e8;
}

.safedigLoginFooter .safedigCustomFooter {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
}

.safedigindiana811Logo {
  height: 60px;
  width: auto;
}

.copyright {
  margin: 0;
  color: #6b6b6b;
  font-size: 0.85rem;
  line-height: 1.5;
}
</style>
